/* Mastermall – köpruta, galleri och klistrig köpknapp.
   Priser kommer alltid från Shopify-varianterna i sidans JSON. */
(function () {
  if (window.MMKjopLoaded) return;
  window.MMKjopLoaded = true;

  var lang = document.documentElement.lang || 'nb';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NOK';

  function money(cents) {
    var amount = cents / 100;
    var whole = Math.round(amount * 100) % 100 === 0;
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(amount);
    } catch (e) {
      return amount.toFixed(whole ? 0 : 2) + ' kr';
    }
  }

  function fill(template, map) {
    return String(template || '').replace(/\{(\w+)\}/g, function (m, k) {
      return map[k] != null ? map[k] : m;
    });
  }

  function emit(name, detail) {
    window.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  /* ---------- Galleri ---------- */
  function initGallery(root) {
    if (!root || root.dataset.mmReady) return;
    root.dataset.mmReady = '1';
    var track = root.querySelector('[data-mm-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.mm-gal__thumb'));
    if (!track) return;

    function slides() {
      return Array.prototype.slice.call(track.querySelectorAll('.mm-gal__slide')).filter(function (s) {
        return !s.hidden;
      });
    }
    function setActive(id) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mediaId === String(id));
      });
      var active = root.querySelector('.mm-gal__thumb.is-active');
      if (active && active.parentElement) {
        var p = active.parentElement;
        var left = active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    function goTo(id, smooth) {
      var slide = track.querySelector('.mm-gal__slide[data-media-id="' + id + '"]');
      if (!slide) return;
      if (slide.hidden) {
        track.querySelectorAll('.mm-gal__slide[data-extra]').forEach(function (s) { s.hidden = true; });
        thumbs.forEach(function (t) { if (t.hasAttribute('data-extra')) t.hidden = true; });
        slide.hidden = false;
        var th = root.querySelector('.mm-gal__thumb[data-media-id="' + id + '"]');
        if (th) th.hidden = false;
      }
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(id);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(t.dataset.mediaId, true); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var list = slides();
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        var s = list[Math.min(Math.max(i, 0), list.length - 1)];
        if (s) setActive(s.dataset.mediaId);
      });
    }, { passive: true });
    root.mmGoTo = goTo;
  }

  /* ---------- Köpruta ---------- */
  class MMKjop extends HTMLElement {
    connectedCallback() {
      var cfgEl = this.querySelector('[data-mm-config]');
      if (!cfgEl) return;
      this.cfg = JSON.parse(cfgEl.textContent);
      this.variants = this.cfg.variants || [];
      this.form = this.querySelector('[data-mm-form]');
      this.btn = this.querySelector('[data-mm-buy]');
      this.btnLabel = this.querySelector('[data-mm-buy-label]');
      this.btnText = this.btn ? this.btn.dataset.label || '' : '';
      this.errorEl = this.querySelector('[data-mm-error]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-mm-pk]'));
      this.gallery = this.closest('section') && this.closest('section').querySelector('[data-mm-gallery]');
      initGallery(this.gallery);

      var cur = this.variants.find((v) => v.id === this.cfg.current) || this.variants[0];
      this.options = cur ? cur.options.slice() : [];
      this.pk = this.cfg.packages.length ? this.cfg.preselect || 0 : -1;

      this.addEventListener('change', (e) => {
        var t = e.target;
        if (t.name && t.name.indexOf('mm-pk-') === 0) {
          this.pk = parseInt(t.value, 10);
          this.update(true);
        } else {
          var fs = t.closest('[data-mm-option]');
          if (fs) {
            this.options[parseInt(fs.dataset.mmOption, 10) - 1] = t.value;
            var lbl = fs.querySelector('[data-mm-option-value]');
            if (lbl) lbl.textContent = t.value;
            this.update(true);
          } else {
            var row = t.closest('[data-mm-row]');
            if (row) {
              var rl = row.querySelector('[data-mm-option-value]');
              if (rl) rl.textContent = t.value;
              this.showValue(t.value);
            }
          }
        }
      });
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.add();
        });
      }
      window.addEventListener('mm:select', (e) => {
        var i = e.detail && e.detail.index;
        if (typeof i !== 'number' || !this.cards[i]) return;
        var input = this.cards[i].querySelector('input');
        if (input) input.checked = true;
        this.pk = i;
        this.update(false);
      });
      window.addEventListener('mm:add', () => this.add());

      this.multi = this.querySelector('[data-mm-multi]');
      this.initDelivery();
      this.initCount();
      this.endGifts();
      this.update(false);
    }

    /* Färg per produkt: visa lika många färgval som paketet har produkter. */
    syncRows(n) {
      var m = this.multi;
      if (!m) return;
      Array.prototype.forEach.call(m.querySelectorAll('[data-mm-row]'), function (r, i) {
        r.hidden = i >= n;
        var l = r.querySelector('[data-mm-row-label]');
        if (l) l.textContent = n > 1 ? String(m.dataset.row || '').replace('{n}', i + 1) : m.dataset.name;
      });
    }

    rowValues(n) {
      if (!this.multi) return [];
      return Array.prototype.slice.call(this.multi.querySelectorAll('[data-mm-row]'), 0, n).map(function (r) {
        var c = r.querySelector('input:checked');
        return c ? c.value : '';
      });
    }

    showValue(value) {
      var pos = this.multi ? parseInt(this.multi.dataset.mmMulti, 10) - 1 : -1;
      if (pos < 0 || !this.gallery || !this.gallery.mmGoTo) return;
      var v = this.variants.find(function (x) { return x.options[pos] === value && x.featured_media; });
      if (v) this.gallery.mmGoTo(v.featured_media.id, true);
    }

    /* Nedräkning till ett fast slutdatum. Nollställs aldrig; raden döljs när tiden gått ut. */
    initCount() {
      var el = this.querySelector('[data-mm-count]');
      if (!el) return;
      var end = parseInt(el.dataset.end, 10) * 1000;
      var self = this;
      var t = el.querySelector('[data-mm-count-time]');
      var iv;
      function p(n) { return n < 10 ? '0' + n : n; }
      function tick() {
        var s = Math.floor((end - Date.now()) / 1000);
        if (!(s > 0)) { el.hidden = true; clearInterval(iv); self.endGifts(); return; }
        var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
        if (t) t.textContent = (d > 0 ? d + 'd ' : '') + p(h) + 't ' + p(m) + 'm ' + p(x) + 's';
      }
      tick();
      iv = setInterval(tick, 1000);
    }

    /* Gåvorna slutar med nedräkningen (blockinställning gaver_slutter): dölj dem och lägg dem inte i varukorgen. */
    giftsOver() {
      return !!(this.cfg.giftsEnd && Date.now() >= this.cfg.giftsEnd * 1000);
    }

    endGifts() {
      if (!this.giftsOver()) return;
      this.querySelectorAll('.mm-gifts').forEach(function (g) { g.style.display = 'none'; });
    }

    variantFor(pkIndex) {
      var opts = this.options.slice();
      var pkg = this.cfg.packages[pkIndex];
      if (this.cfg.mode === 'variant' && pkg) opts[this.cfg.pkPos - 1] = pkg.verdi;
      return this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    priceFor(pkIndex) {
      var v = this.variantFor(pkIndex);
      var pkg = this.cfg.packages[pkIndex] || { antall: 1 };
      var qty = this.cfg.mode === 'antall' ? pkg.antall || 1 : 1;
      if (!v) return null;
      var price = v.price * qty;
      var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price * qty : 0;
      return { v: v, qty: qty, price: price, compare: compare, units: pkg.antall || 1 };
    }

    update(userAction) {
      var self = this;
      this.cards.forEach(function (card, i) {
        var p = self.priceFor(i);
        card.classList.toggle('is-selected', i === self.pk);
        card.classList.toggle('is-disabled', !p || !p.v.available);
        var priceEl = card.querySelector('[data-mm-price]');
        var cmpEl = card.querySelector('[data-mm-compare]');
        var saveEl = card.querySelector('[data-mm-save]');
        var unitEl = card.querySelector('[data-mm-unit]');
        if (!p) {
          if (priceEl) priceEl.textContent = self.cfg.soldOut;
          if (cmpEl) cmpEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
          if (unitEl) unitEl.textContent = '';
          return;
        }
        if (priceEl) priceEl.textContent = p.v.available ? money(p.price) : self.cfg.soldOut;
        if (cmpEl) {
          cmpEl.hidden = !p.compare;
          cmpEl.textContent = p.compare ? money(p.compare) : '';
        }
        if (saveEl) {
          saveEl.hidden = !p.compare;
          saveEl.textContent = p.compare ? fill(self.cfg.saveLabel, { belop: money(p.compare - p.price) }) : '';
        }
        if (unitEl) {
          unitEl.textContent = p.units > 1 ? fill(self.cfg.perUnit, { pris: money(Math.round(p.price / p.units)) }) : '';
        }
      });

      var sel = this.pk >= 0 ? this.priceFor(this.pk) : null;
      var v = sel ? sel.v : this.variants.find((x) => x.options.every((o, i) => o === this.options[i]));
      var qty = sel ? sel.qty : 1;
      this.selected = { v: v, qty: qty, units: sel ? sel.units : 1 };
      this.syncRows(this.selected.units);

      if (this.form && v) {
        this.form.querySelector('[name="id"]').value = v.id;
        this.form.querySelector('[name="quantity"]').value = qty;
      }
      var available = !!(v && v.available);
      if (this.btn) {
        this.btn.disabled = !available;
        if (this.btnLabel) this.btnLabel.textContent = available ? this.btnText : this.cfg.soldOut;
      }
      var single = this.querySelector('[data-mm-single-price]');
      if (single && v) single.textContent = money(v.price);
      var singleCmp = this.querySelector('[data-mm-single-compare]');
      if (singleCmp && v) {
        singleCmp.hidden = !(v.compare_at_price > v.price);
        singleCmp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      }

      if (v && v.featured_media && this.gallery && this.gallery.mmGoTo && userAction) {
        this.gallery.mmGoTo(v.featured_media.id, true);
      }
      if (v && userAction) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      var pkg = this.cfg.packages[this.pk] || {};
      var state = {
        packages: this.cfg.packages.map(function (p, i) {
          return { label: p.kort || p.navn, badge: p.badge || '', selected: i === self.pk };
        }),
        price: v ? money(sel ? sel.price : v.price) : '',
        compare: sel && sel.compare ? money(sel.compare) : v && !sel && v.compare_at_price > v.price ? money(v.compare_at_price) : '',
        perks: pkg.fordeler || '',
        available: available,
        label: available ? this.btnText : this.cfg.soldOut,
      };
      window.MMState = state;
      emit('mm:state', state);
    }

    initDelivery() {
      var el = this.querySelector('[data-mm-delivery]');
      if (!el) return;
      function addBusinessDays(d, n) {
        var x = new Date(d);
        while (n > 0) {
          x.setDate(x.getDate() + 1);
          if (x.getDay() !== 0 && x.getDay() !== 6) n--;
        }
        return x;
      }
      var f = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' });
      var now = new Date();
      var a = f.format(addBusinessDays(now, parseInt(el.dataset.min, 10) || 0));
      var b = f.format(addBusinessDays(now, parseInt(el.dataset.max, 10) || 0));
      el.querySelector('[data-mm-delivery-text]').textContent = fill(el.dataset.template, { fra: a, til: b });
    }

    async add() {
      var s = this.selected;
      if (!s || !s.v || !s.v.available || this.busy) return;
      this.busy = true;
      if (this.btn) this.btn.classList.add('is-loading');
      if (this.errorEl) this.errorEl.hidden = true;
      emit('mm:busy', true);

      var items = [{ id: s.v.id, quantity: s.qty }];
      if (this.multi && s.units > 1) {
        var props = {};
        props[this.multi.dataset.prop || 'Farger'] = this.rowValues(s.units).join(', ');
        items[0].properties = props;
      }
      var giftsOver = this.giftsOver();
      (this.cfg.gifts || []).forEach(function (g) {
        if (!giftsOver && g.variantId && g.free && s.units >= g.min) {
          items.push({ id: g.variantId, quantity: 1, properties: { _gave: 'Gratis' } });
        }
      });

      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && this.cfg.after !== 'checkout') {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      var routes = window.routes || {};
      try {
        var res = await fetch((routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        var json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'Feil');
        if (this.cfg.after === 'checkout') {
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          window.location.href = root + 'checkout';
          return;
        }
        if (drawer && json.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(json);
        } else {
          window.location.href = routes.cart_url || '/cart';
        }
      } catch (err) {
        if (this.errorEl) {
          this.errorEl.textContent = err.message;
          this.errorEl.hidden = false;
        }
      } finally {
        this.busy = false;
        if (this.btn) this.btn.classList.remove('is-loading');
        emit('mm:busy', false);
      }
    }
  }
  if (!customElements.get('mm-kjop')) customElements.define('mm-kjop', MMKjop);

  /* ---------- Klistrig köpknapp ---------- */
  class MMSticky extends HTMLElement {
    connectedCallback() {
      this.pills = this.querySelector('[data-mm-sticky-pills]');
      this.priceEl = this.querySelector('[data-mm-sticky-price]');
      this.cmpEl = this.querySelector('[data-mm-sticky-compare]');
      this.perksEl = this.querySelector('[data-mm-sticky-perks]');
      this.btn = this.querySelector('[data-mm-sticky-buy]');
      this.btnLabel = this.querySelector('[data-mm-sticky-label]');
      this.closed = false;
      try { this.closed = sessionStorage.getItem('mm-sticky-closed') === '1'; } catch (e) {}

      window.addEventListener('mm:state', (e) => this.render(e.detail));
      window.addEventListener('mm:busy', (e) => this.btn && this.btn.classList.toggle('is-loading', !!e.detail));
      if (window.MMState) this.render(window.MMState);

      if (this.btn) this.btn.addEventListener('click', () => emit('mm:add'));
      var close = this.querySelector('[data-mm-sticky-close]');
      if (close) close.addEventListener('click', () => {
        this.closed = true;
        this.toggle(false);
        try { sessionStorage.setItem('mm-sticky-closed', '1'); } catch (e) {}
      });
      this.observe();
    }

    observe() {
      var target = document.querySelector('[data-mm-buy]');
      if (!target || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
          this.toggle(passed && !this.closed);
        });
      });
      io.observe(target);
    }

    toggle(show) {
      // I förhandsvisningen ligger Shopifys förhandsvisningsrad över botten: lyft baren ovanför den.
      var pb = document.getElementById('PBarNextFrameWrapper');
      var h = pb ? Math.round(pb.getBoundingClientRect().height) : 0;
      this.style.bottom = h > 0 ? h + 'px' : '';
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('mm-sticky-open', show);
    }

    render(s) {
      if (!s) return;
      if (this.pills) {
        this.pills.innerHTML = '';
        this.pills.hidden = s.packages.length < 2;
        s.packages.forEach(function (p, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'mm-sticky__pill' + (p.selected ? ' is-selected' : '');
          b.setAttribute('aria-pressed', p.selected ? 'true' : 'false');
          if (p.badge) {
            var bd = document.createElement('span');
            bd.className = 'mm-sticky__badge';
            bd.textContent = p.badge;
            b.appendChild(bd);
          }
          b.appendChild(document.createTextNode(p.label));
          b.addEventListener('click', function () { emit('mm:select', { index: i }); });
          this.pills.appendChild(b);
        }, this);
      }
      if (this.priceEl) this.priceEl.textContent = s.price;
      if (this.cmpEl) { this.cmpEl.textContent = s.compare; this.cmpEl.hidden = !s.compare; }
      if (this.perksEl) { this.perksEl.textContent = s.perks; this.perksEl.hidden = !s.perks; }
      if (this.btn) this.btn.disabled = !s.available;
      if (this.btnLabel && this.btnLabel.dataset.fixed !== '1') this.btnLabel.textContent = s.label;
    }
  }
  if (!customElements.get('mm-sticky')) customElements.define('mm-sticky', MMSticky);
})();
